import React, { useState, useRef } from "react";
import Map, { Source, Layer } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { geohazards } from "../../constants/formOptions";
import IssueBubble from "../IssueBubble";
import bbox from '@turf/bbox';
import { featureCollection } from '@turf/helpers';

function StepExistingIssue({ formData, updateFormData }) {
  const mapRef = useRef();
  const [viewport, setViewport] = useState({
    latitude: 41.8719,
    longitude: 12.56,
    zoom: 10,
  });
  const [layers, setLayers] = useState([]);

  const handleAddIssue = (geohazard, issue) => {
    if (issue.geometry) {
      const newLayer = {
        id: `layer-${geohazard.value}-${issue._id}`,
        type: "fill",
        source: {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: issue.geometry.features
          }
        },
        paint: {
          'fill-opacity': 0.5,
          'fill-color': issue.color
        }
      };

      setLayers(prevLayers => {
        const updatedLayers = [...prevLayers, newLayer];
        
        const featureCollectionData = featureCollection(updatedLayers.map(layer => layer.source.data.features).flat());
        const bounds = bbox(featureCollectionData);
        mapRef.current.fitBounds([[bounds[0], bounds[1]], [bounds[2], bounds[3]]], {
          padding: 20,
          duration: 1000
        });

        return updatedLayers;
      });
    }

    const updatedGeohazards = [...(formData.geohazards || []), { ...issue, geohazardType: geohazard.value }];
    updateFormData("geohazards", updatedGeohazards);
  }

  const handleRemoveIssue = (geohazard, issue) => {
    setLayers(prevLayers => {
      const updatedLayers = prevLayers.filter(layer => layer.id !== `layer-${geohazard.value}-${issue._id}`);
      
      if (updatedLayers.length > 0) {
        const featureCollectionData = featureCollection(updatedLayers.map(layer => layer.source.data.features).flat());
        const bounds = bbox(featureCollectionData);
        mapRef.current.fitBounds([[bounds[0], bounds[1]], [bounds[2], bounds[3]]], {
          padding: 20,
          duration: 1000
        });
      }

      return updatedLayers;
    });

    const updatedGeohazards = (formData.geohazards || []).filter(i => i._id !== issue._id);
    updateFormData("geohazards", updatedGeohazards);
  }

  return (
    <div>
      <h6>Existing Issue</h6>
      <div className="row-flex">
        <div>
          {geohazards.map((geohazard, index) => (
            <IssueBubble
              name={geohazard.label}
              properties={geohazard.properties}
              existingIssues={formData.geohazards.filter(i => i.geohazardType === geohazard.value)}
              key={index}
              onItemAdd={(issue) => handleAddIssue(geohazard, issue)}
              onItemRemove={(issue) => handleRemoveIssue(geohazard, issue)} />
          ))}
        </div>
        <div className="map-wrapper">
          <Map
            ref={mapRef}
            className="area-map"
            mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
            initialViewState={viewport}
            mapStyle="mapbox://styles/mapbox/streets-v11"
            onMove={(evt) => setViewport(evt.viewState)}
          >
            {layers.map(layer => (
              <Source key={layer.id} id={layer.id} type="geojson" data={layer.source.data}>
                <Layer
                  id={layer.id}
                  type={layer.type}
                  paint={layer.paint}
                />
              </Source>
            ))}
          </Map>
        </div>
      </div>
    </div>
  );
}

export default StepExistingIssue;
